<template>
<div class="chapter">
<div class="inner_page">
<div class="box_double">
<h2 class="section" id="c01_sec3"><a id="page16"></a><span href="#/OEBPS/toc#c01_sec3" title="Link target outside of Sample"><strong>Lavender</strong></span></h2>
<p class="nonindent">Provence conjures up images of lavender etching purple lines across the French countryside. If you’re lucky enough to visit in summer, you can see fields carpeted with blooms.</p>
<p class="indent">The lavender-like plant grown at lower elevations is <em>lavandin</em>, a sterile hybrid form with a slight camphor-like scent. Pure lavender, or <em>lavande fin</em>, grows only at higher altitudes (600–2000 meters), such as around Sault. Since insects have become a big problem, growers are planting at higher elevations to avoid the pests. They’re forbidden to use chemical pesticides in consideration of the bees. Fine lavender is becoming rare, and more fields are getting planted with the hardier <em>lavandin</em>. A way to tell the two apart is that each stem of <em>lavande fin</em> has a single flower, while <em>lavandin</em> has three flowers.</p>
<p class="indent">Lavender’s growing season conveniently coincides with the peak of tourism. The Luberon valley begins lighting up with blue blooms in late June and continues until early August. The cycle runs about two weeks later in higher elevations, from July until mid-August. The lavender fields at Abbaye de Sénanque, near Gordes, are technically <em>lavandin</em>, but that doesn’t make the sight <a id="page17"></a>any less spectacular to behold. Peak times are late June through July. I also recommend a visit to Sault (which holds a lavender festival on August 15) or follow the Lavender Route, a circuit that passes fields and distilleries. A lavender museum in Coustellet explains how the plants are cultivated and the distillation process.</p>
<p class="figure"><img alt="" src="OEBPS/images/17-1.jpg"/></p>
</div>
<p class="figure"><a id="page18"></a><img alt="" src="OEBPS/images/18-1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c01_sec3.vue?fbb6addc